/**
 * Styled Components - Created by david on 29/05/18.
 */
import styled from 'styled-components'

export const Container = styled.div`
  height: 55vh;
  padding: 12px 0px;
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/DesignerTool/DesignCenterCustomize/FillColor/styledComponents.tsx